<template>
  <div>
    <div v-if="contactInformation" class="contact-form__company-info">
      <div v-if="contactInformation.name">
        <label>
          <strong v-html="contactInformation.name"></strong>
        </label>
      </div>
      <div v-if="contactInformation.address">
        <label v-html="contactInformation.address"></label>
      </div>
      <div v-if="contactInformation.city">
        <label v-html="contactInformation.city"></label>
      </div>
    </div>
    <div
      class="contact-form__company-info"
      v-if="contactInformation && contactInformation.phone"
    >
      <label
        @click="
          () => {
            this.phoneNumberShown = true
            LogPhoneNumberShown()
          }
        "
        v-if="
          !phoneNumberShown && !contactInformation.showPhoneNumberWithoutClick
        "
      >
        <span class="-ml-1"><span class="badge">Vis telefonnummer</span></span>
      </label>
      <label v-else class="contact-phone__container">
        <a
          tabindex="-1"
          @click="LogPhoneNumberClick($event)"
          :href="contactInformation.phoneUrl"
          class="contact-phone__phone"
        >
          {{ contactInformation.phone }}
        </a>
        <a
          class="inline-block"
          @click="LogPhoneNumberClick($event)"
          :href="contactInformation.phoneUrl"
        >
          <span class="badge"> Ring til {{ vendorInformation.plural }} </span>
        </a>
        <br />
        <span class="contact-phone__phone-text">
          Husk at sige du har været på Biltorvet
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import { LogPhoneNumberClick, LogPhoneNumberShown } from '@/events'

export default {
  props: {
    contactInformation: { default: undefined, type: Object },
    vendorInformation: { default: undefined, type: Object },
    id: { default: undefined, type: Number },
    originSource: { default: '', type: String },
  },
  data() {
    return {
      phoneNumberShown: false,
      phoneNumberClicked: false,
    }
  },
  methods: {
    LogPhoneNumberClick(event) {
      if (!this.phoneNumberClicked) {
        event.preventDefault()

        LogPhoneNumberClick(this.originSource, this.id).then(() => {
          this.phoneNumberClicked = true

          event.target.click()
        })
      }
    },
    LogPhoneNumberShown() {
      LogPhoneNumberShown(this.originSource, this.id)
    },
  },
}
</script>

<style lang="scss">
@import 'ContactForm.scss';
</style>
